var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_upload",
    "data-name": "icona upload",
    transform: "translate(-604 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_upload-2",
    "data-name": "icona upload",
    transform: "translate(595.983 -7.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_723",
    "data-name": "Raggruppa 723",
    transform: "translate(8.017 10.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_163",
    "data-name": "Tracciato 163",
    d: "M35.784,29.022a12.745,12.745,0,0,0-23.615-4.234,7.3,7.3,0,0,0-1.339-.127,6.985,6.985,0,0,0-6.976,6.976A7.626,7.626,0,0,0,4,33.085a9.707,9.707,0,0,0-4,7.826,10.378,10.378,0,0,0,2.633,6.867,9.4,9.4,0,0,0,6.514,3.275H17a1.221,1.221,0,0,0,0-2.443H9.256c-3.7-.226-6.813-3.746-6.813-7.709a7.252,7.252,0,0,1,3.592-6.243,1.231,1.231,0,0,0,.534-1.484A4.432,4.432,0,0,1,6.3,31.619a4.541,4.541,0,0,1,4.533-4.533,4.455,4.455,0,0,1,1.547.271,1.227,1.227,0,0,0,1.529-.624,10.3,10.3,0,0,1,19.571,3.393,1.22,1.22,0,0,0,1.013,1.086,8.805,8.805,0,0,1-.832,17.39H26.99a1.221,1.221,0,0,0,0,2.443h6.8a10.825,10.825,0,0,0,7.256-3.583,11.261,11.261,0,0,0-5.266-18.44Z",
    transform: "translate(0 -18.4)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_164",
    "data-name": "Tracciato 164",
    d: "M173.242,193.959a1.218,1.218,0,0,0,0-1.728l-6.469-6.469a1.236,1.236,0,0,0-.86-.362,1.2,1.2,0,0,0-.86.362l-6.469,6.469a1.226,1.226,0,0,0,.86,2.09,1.192,1.192,0,0,0,.86-.362l4.388-4.388v20.168a1.221,1.221,0,1,0,2.443,0V189.571l4.388,4.388A1.207,1.207,0,0,0,173.242,193.959Z",
    transform: "translate(-143.909 -170.29)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_770",
    "data-name": "Rettangolo 770",
    transform: "translate(604 1)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f8b1bdb266f966e7703565f7035b8d50.svg";
export { ForwardRef as ReactComponent };